import React, { useState } from 'react';

import Interior1 from '../../assets/interiors/interior1.jpg';
import Interior2 from '../../assets/interiors/interior2.jpg';
import Interior3 from '../../assets/interiors/interior3.jpg';
import Interior4 from '../../assets/interiors/interior4.jpg';

const Interior = () => {
    const interior = [
        {
            images: [Interior1, Interior2, Interior3, Interior4],
        }
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % interior[0].images.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + interior[0].images.length) % interior[0].images.length);
    };

    return (
        <div className="w-[80vw] h-full">
            <div className="pt-16 w-full h-full grid grid-cols-1 py-10">
                <div
                    className="w-full h-full flex flex-col justify-end items-end rounded-xl relative overflow-hidden"
                    style={{
                        backgroundImage: `url(${interior[0].images[currentImageIndex]})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        transition: 'background-image 0.8s ease-in-out',
                    }}
                >
                    <div className="absolute w-full h-full bg-black opacity-30 z-0"></div>
                    {/* Carousel Controls */}
                    <div className="absolute top-1/2 left-5 z-30">
                        <button onClick={prevImage} className="text-white bg-black bg-opacity-50 p-2 font-semibold rounded-full">
                            ‹
                        </button>
                    </div>
                    <div className="absolute top-1/2 right-5 z-30">
                        <button onClick={nextImage} className="text-white bg-black bg-opacity-50 p-2 font-semibold rounded-full">
                            ›
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Interior;
